/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClassSession,
    ClassSessionFromJSON,
    ClassSessionFromJSONTyped,
    ClassSessionToJSON,
} from './ClassSession';

/**
 * 
 * @export
 * @interface Announcement
 */
export interface Announcement {
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    shortURL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    category?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Announcement
     */
    priority?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Announcement
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Announcement
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Announcement
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Announcement
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    webMessage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Announcement
     */
    showOnWeb?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    emailMessage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Announcement
     */
    sendEmail?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    smsMessage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Announcement
     */
    sendSMS?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    classSessionId?: string | null;
    /**
     * 
     * @type {ClassSession}
     * @memberof Announcement
     */
    classSession?: ClassSession;
}

export function AnnouncementFromJSON(json: any): Announcement {
    return AnnouncementFromJSONTyped(json, false);
}

export function AnnouncementFromJSONTyped(json: any, ignoreDiscriminator: boolean): Announcement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'shortURL': !exists(json, 'shortURL') ? undefined : json['shortURL'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'dateCreated': !exists(json, 'dateCreated') ? undefined : (new Date(json['dateCreated'])),
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'webMessage': !exists(json, 'webMessage') ? undefined : json['webMessage'],
        'showOnWeb': !exists(json, 'showOnWeb') ? undefined : json['showOnWeb'],
        'emailMessage': !exists(json, 'emailMessage') ? undefined : json['emailMessage'],
        'sendEmail': !exists(json, 'sendEmail') ? undefined : json['sendEmail'],
        'smsMessage': !exists(json, 'smsMessage') ? undefined : json['smsMessage'],
        'sendSMS': !exists(json, 'sendSMS') ? undefined : json['sendSMS'],
        'classSessionId': !exists(json, 'classSessionId') ? undefined : json['classSessionId'],
        'classSession': !exists(json, 'classSession') ? undefined : ClassSessionFromJSON(json['classSession']),
    };
}

export function AnnouncementToJSON(value?: Announcement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'shortURL': value.shortURL,
        'title': value.title,
        'category': value.category,
        'priority': value.priority,
        'isActive': value.isActive,
        'dateCreated': value.dateCreated === undefined ? undefined : (value.dateCreated.toISOString()),
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'webMessage': value.webMessage,
        'showOnWeb': value.showOnWeb,
        'emailMessage': value.emailMessage,
        'sendEmail': value.sendEmail,
        'smsMessage': value.smsMessage,
        'sendSMS': value.sendSMS,
        'classSessionId': value.classSessionId,
        'classSession': ClassSessionToJSON(value.classSession),
    };
}

